export default "__VITE_ASSET__BjKCVuPR__"